module.exports = __webpack_public_path__ + "img/pile28801.20ff9e2a.png";